/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type FaqPage_viewer$ref = any;
export type queries_FaqPage_QueryVariables = {};
export type queries_FaqPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": FaqPage_viewer$ref;
    }) | null;
};
export type queries_FaqPage_Query = {
    readonly response: queries_FaqPage_QueryResponse;
    readonly variables: queries_FaqPage_QueryVariables;
};



/*
query queries_FaqPage_Query {
  viewer {
    id
    ...FaqPage_viewer
  }
}

fragment FaqPage_viewer on Viewer {
  id
  user {
    id
    role
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_FaqPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "FaqPage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_FaqPage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "queries_FaqPage_Query",
            "id": null,
            "text": "query queries_FaqPage_Query {\n  viewer {\n    id\n    ...FaqPage_viewer\n  }\n}\n\nfragment FaqPage_viewer on Viewer {\n  id\n  user {\n    id\n    role\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '042a6e8980f606260cf92c1b10b8ebd0';
export default node;
